import { WizardProvider, useWizard } from '../hooks/WizardProvider';
import Layout from '../components/Layout';
import Details from '../steps/organisation/Details';
import Creation from '../steps/account/Creation';
import OrganisationMapping from '../steps/mapping/OrganisationMapping';
import Users from '../steps/profile/Users';
import Setup from '../steps/whatsapp/Setup';
import Goal from '../steps/campaign/Goal';
import Builder from '../steps/form-builder/Builder';
import { FeatureThemeProvider } from '../../../theme/FeatureThemeProvider';

function StepRenderer() {
  const { currentStep } = useWizard();

  switch (currentStep) {
    case 1:
      return <Details />;
    case 2:
      return <Creation />;
    case 3:
      return <OrganisationMapping />;
    case 4:
      return <Users />;
    case 5:
      return <Setup />;
    case 6:
      return <Goal />;
    case 7:
      return <Builder />;
    default:
      return <Details />;
  }
}

export default function OnboardingPage() {
  return (
    <FeatureThemeProvider>
      <WizardProvider>
        <Layout>
          <StepRenderer />
        </Layout>
      </WizardProvider>
    </FeatureThemeProvider>
  );
}
